import {
  doc,
  Firestore,
  getDoc,
  setDoc,
  Timestamp,
} from "firebase/firestore/lite";
import { firebaseDb } from "../firebase/client-app";
import { DbRewardSettings, RedeemPointsRequest } from "./models";
import { axiosInstance } from "../rest/axios";
import { getCookie } from "cookies-next";

export class RewardSettingService {
  private businessPrivateRef(firestore: Firestore, businessId: string) {
    return doc(
      firestore,
      `businesses/${businessId}/business_private/reward_settings`,
    );
  }

  async getRewardSettings(
    businessId: string,
    firestore: Firestore = firebaseDb,
  ): Promise<DbRewardSettings | null> {
    const docRef = this.businessPrivateRef(firestore, businessId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      return null;
    }

    return docSnap.data() as DbRewardSettings;
  }

  async saveRewardSettings(
    businessId: string,
    rewardSettings: Omit<DbRewardSettings, "created_at">,
    firestore: Firestore = firebaseDb,
  ): Promise<void> {
    const docRef = this.businessPrivateRef(firestore, businessId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      const newSettings: DbRewardSettings = {
        ...rewardSettings,
        created_at: Timestamp.now(),
      };
      await setDoc(docRef, newSettings);
    } else {
      await setDoc(docRef, rewardSettings, { merge: true });
    }
  }

  async redeemPoints(
    businessId: string,
    pointsToRedeem: number,
    billAmount: number,
    clientId?: string,
  ): Promise<void> {
    const payload: RedeemPointsRequest = {
      business_id: businessId,
      points_to_redeem: pointsToRedeem,
      bill_amount: billAmount,
    };

    if (clientId) {
      payload.client_id = clientId;
    }

    await axiosInstance.post("/reward/redeem", payload, {
      headers: { Authorization: getCookie("Authorization")?.toString() },
    });
  }
}

export const rewardSettingService = new RewardSettingService();
